import React, { useEffect, useState } from "react";
import {
  DialogComponent,
  TooltipComponent,
} from "@syncfusion/ej2-react-popups";
import { useTranslation } from "react-i18next";
import Datagrid from "./Datagrid";
import DatagridContext from "../Context/datagridContext";
import { MaskedTextBoxComponent } from "@syncfusion/ej2-react-inputs";

const ContactModal = ({ isOpen, onClose, onSelectContact }) => {
  const [url, setUrl] = useState("");
  const [from, setFrom] = useState("");
  const [selectedContacts, setSelectedContacts] = useState([]);
  const { t } = useTranslation();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const fetchData = async () => {
    setUrl(`${baseUrl}/contacts`);
    setFrom("Contacts-Modal");
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSelectionChange = (selectedRecords) => {
    setSelectedContacts(selectedRecords);
  };

  const handleClose = () => {
    onSelectContact(selectedContacts);
    onClose();
  };

  const editTemplate = (props) => {
    return (
      <MaskedTextBoxComponent
        id={`phoneNumber_${props.rowIndex}`}
        name="phoneNumber"
        placeholder={t("Phone Number")}
        onChange={(e) => {
          if (props.onChange) {
            props.onChange({
              target: {
                name: "phoneNumber",
                value: e.value,
              },
            });
          }
        }}
        mask={"+90 (000)-000-0000"}
        value={props.phoneNumber || ""}
        floatLabelType="Always"
      />
    );
  };

  const formatPhoneNumber = (value) => {
    if (!value) return "";
    const numericValue = value.replace(/[^0-9]/g, "");
    if (numericValue.length !== 12) return value;

    return `+${numericValue.slice(0, 2)} (${numericValue.slice(
      2,
      5
    )})-${numericValue.slice(5, 8)}-${numericValue.slice(8)}`;
  };

  // console.log(selectedContacts);
  const columns = [
    {
      field: "id",
      headerText: "id",
      allowEditing: false,
      isPrimaryKey: true,
      visible: false,
    },
    {
      field: "code",
      headerText: t("Code"),
      allowEditing: true,
      validationRules: { required: true },
    },
    {
      field: "definition",
      headerText: t("Definition"),
      allowEditing: true,
    },
    {
      field: "address",
      headerText: t("Address"),
      allowEditing: true,
    },
    {
      field: "city",
      headerText: t("City"),
      allowEditing: true,
    },
    {
      field: "country",
      headerText: t("Country"),
      allowEditing: true,
    },
    {
      field: "inCharge",
      headerText: t("InCharge"),
      allowEditing: true,
    },
    {
      field: "phoneNumber",
      headerText: t("Phone Number"),
      allowEditing: true,
      editTemplate: editTemplate,
      template: (props) => formatPhoneNumber(props.phoneNumber),
      
    },
    {
      field: "isEnabled",
      headerText: t("isEnabled"),
      allowEditing: false,
      isCheckbox: "True",
      textAlign: "Center",
    },
  ];
  const settings = { effect: "Zoom", duration: 400, delay: 0 };

  function header() {
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <span>{t("Contacts")}</span>
        <TooltipComponent
          content={`<div>${t("Hold Ctrl to select multiple items")}<br />
          ${t("Use Shift to select a range of items")}<br />
          ${t("CtrlA")}<br />${t("Only enabled")}</div>`}
          position="BottomCenter"
        >
          <span
            className="e-icons e-large e-circle-info"
            style={{ marginLeft: "8px", fontSize: "25px", cursor: "pointer" }}
          ></span>
        </TooltipComponent>
      </div>
    );
  }

  const buttons = [
    {
      buttonModel: {
        content: t("Choose"),
        cssClass: "e-flat",
        isPrimary: true,
      },
      click: () => {
        handleClose();
      },
    },
    {
      buttonModel: {
        content: t("Cancel"),
        cssClass: "e-flat",
      },
      click: () => {
        handleClose();
      },
    },
  ];

  return (
    <DialogComponent
      header={header}
      visible={isOpen}
      width="100vw"
      height="90vh"
      showCloseIcon={true}
      close={handleClose}
      zIndex={1000001}
      animationSettings={settings}
      closeOnEscape={false}
      buttons={buttons}
    >
      <DatagridContext.Provider
        value={{
          url,
          from,
        }}
      >
        <Datagrid columns={columns} onSelectionChange={handleSelectionChange} />
      </DatagridContext.Provider>
    </DialogComponent>
  );
};

export default ContactModal;
